import { ICard, ICardDetails } from './Card';
import { IIdentity } from './Identity';

export enum PaymentNotificationMethod {
  BOTH = 'both',
  EMAIL = 'email',
  NONE = 'none',
  TEXT = 'text',
}

export interface IUser {
  id: string;
  firstName: string;
  lastName: string;
  avatarUrl?: string;
  hasPin: boolean;
  dateOfBirth: string;
  identities: IIdentity[];
  card?: ICard;
  termsOfService: ITermsOfService[];
  privacyPolicy: IPrivacyPolicy[];
  settings: IUserSettings;
  lastLoginAt?: string;
  remoteSession?: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
}

interface IUserSettings {
  paymentNotificationMethod: PaymentNotificationMethod;
}

interface ITermsOfService {
  version: string;
  createdAt: string;
  updatedAt: string;
}

interface IPrivacyPolicy extends ITermsOfService {}

export interface ISubmittedBy {
  id?: string;
  name: string;
  type: string;
}

export interface IUpdateUserPayload {
  firstName?: string;
  lastName?: string;
  avatarUrl?: string;
  dateOfBirth?: string;
  recoveryPin?: string;
  termsOfService?: ITermsOfService[];
  privacyPolicy?: IPrivacyPolicy[];
  settings?: IUserSettings;
  password?: string;
  existingPassword?: string;
}

export interface IDeleteUserPayload {
  dateOfBirth?: string;
}

export interface IAvatarUrlResponse {
  url: string;
  fields: {
    bucket: string;
    key: string;
    Policy: string;
    success_action_status: string;
    'X-Amz-Algorithm': string;
    'X-Amz-Credential': string;
    'X-Amz-Date': string;
    'X-Amz-Security-Token': string;
    'X-Amz-Signature': string;
    acl: 'public-read';
    file: File;
  };
}

export interface IResetPasswordPayloadProps {
  token: string;
  password: string;
}

export interface IUpdateEmailFormPayload {
  userId: string;
  email: string;
  confirmEmail: string;
}

export interface IUpdateUserPasswordPayloadProps {
  userId: string;
  password: string;
  existing_password: string;
}

export enum UserForm {
  SETTINGS = 'Settings',
  EMAIL = 'Email',
  MOBILE = 'Mobile',
  MOBILE_CONFIRM = 'MobileConfirm',
}

export interface IUserWithDetails extends IUser {
  cardDetail?: ICardDetails;
}

export interface IForgotPasswordPayloadProps {
  identity: string;
  dateOfBirth: string;
}
